/**
 * DR-3149: the reconstruction row of the processing-status card is doc-level, so its counts
 * are projected here rather than read off the wire — and they must follow the same contract
 * as the per-page stages that `DocumentProcessingStatus` consumes: `completedCount` is the
 * TERMINAL count (done/skip/error, mirroring `PageSetCounts.completed`) and `erroredCount`
 * a subset of it, never a disjoint bucket. Building the two as disjoint 0/1 flags made the
 * consumer's `completed - errored` arithmetic report -1 settled units on a failed
 * reconstruction. `totalPages` is the same terminal unit, so a finished reconstruction —
 * successful or failed — renders its one unit instead of disappearing behind a 0 total.
 * `skippedCount` mirrors the same per-page contract: it is also a subset of `completedCount`,
 * never a disjoint bucket, so `completed - skipped - errored` still yields the done segment.
 */
export type ReconstructionRowCounts = {
  completedCount: number;
  erroredCount: number;
  skippedCount: number;
  totalPages: number;
};

export function reconstructionRowCounts(status: string | undefined): ReconstructionRowCounts {
  const isTerminal = status === 'done' || status === 'error' || status === 'skip';

  return {
    completedCount: isTerminal ? 1 : 0,
    erroredCount: status === 'error' ? 1 : 0,
    skippedCount: status === 'skip' ? 1 : 0,
    totalPages: isTerminal ? 1 : 0,
  };
}
